// extracted by mini-css-extract-plugin
module.exports = {"message":"ContentWithoutResult_message__1NsJS","title":"ContentWithoutResult_title__sZ0jA"};